import { DatePicker } from "antd"
import { ClockCircleOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchTelecallerReportSummary } from "../../store/telecaller/telecallerSummary"
import StatsCard from "./SummaryCard"
import moment from "moment"
import "./style.scss"

const TelecallerSummaryReport = () => {
    const { tele_report_summary, tele_report_summary_loading } = useSelector((state) => state.telecallerSummary);
    const dispatch = useDispatch();
    /* the picker was uncontrolled, so nothing on the page said which day the
       figures below belong to once it scrolled out of view */
    const [selectedDate, setSelectedDate] = useState(null);

    useEffect(() => {
        dispatch(fetchTelecallerReportSummary());
    }, [dispatch])

    const durationCards = [
        { key: "answer_duration", title: "Answer Duration" },
        { key: "available_time", title: "Available Time" },
        { key: "login_duration", title: "Log in Duration" },
        { key: "lunch", title: "Lunch" },
        { key: "on_call_duration", title: "On Call Duration" },
        { key: "ring_time", title: "Ring Time" },
        { key: "talk_time", title: "Talk Time" },
        { key: "total_breaks", title: "Total Breaks" },
        { key: "wrap_time", title: "Wrap Time" },
    ];

    const handleDateChange = (val) => {
        setSelectedDate(val || null);
        if (!val) {
            dispatch(fetchTelecallerReportSummary());
        } else {
            const date = val.format("YYYY-MM-DD");
            dispatch(fetchTelecallerReportSummary({ date }));
        }
    };

    return (
        <div className="telecaller-summary-report-container">
            <header className="summaryHeader">
                <div className="summaryHeader__lead">
                    <span className="summaryHeader__icon">
                        <ClockCircleOutlined />
                    </span>
                    <div className="summaryHeader__titles">
                        <h3>Summary Report</h3>
                        <p>
                            How your time broke down on{" "}
                            {selectedDate ? selectedDate.format("DD MMM YYYY") : "the latest day recorded"}.
                        </p>
                    </div>
                </div>

                <DatePicker
                    className="summaryDatePicker"
                    placeholder="Pick a date"
                    value={selectedDate}
                    disabledDate={(current) => {
                        // disable today and all future dates
                        return current && current >= moment().startOf('day');
                    }}
                    onChange={handleDateChange}
                />
            </header>

            <div className="summary-reports-cards">
                {durationCards.map(({ key, title }) => (
                    <StatsCard
                        key={key}
                        title={title}
                        time={tele_report_summary?.[0]?.[key]}
                        loading={tele_report_summary_loading}
                    />
                ))}
            </div>
        </div>
    )
}
export default TelecallerSummaryReport
